/**
 * Mock Election Data
 *
 * Static mock data for development and testing.
 * Based on React prototype: src/electionHub/US Map Design V6/src/app/data/electionData.ts
 */
import type { USStateCode, ElectionContract, PartyCode } from '../types/election.types';

/**
 * Governor race contract data
 * Key: State code, Value: Election contract
 */
export const GOVERNOR_CONTRACT_DATA: Record<USStateCode, ElectionContract> = {
  AL: {
    productConid: 10001,
    stateCode: 'AL',
    name: 'Alabama',
    favorite: 'GOP',
    price: 92,
    volume: '$1.2M',
    openInterest: 12400,
  },
  AK: {
    productConid: 10002,
    stateCode: 'AK',
    name: 'Alaska',
    favorite: 'GOP',
    price: 68,
    volume: '$450K',
    openInterest: 5200,
  },
  AZ: {
    productConid: 10003,
    stateCode: 'AZ',
    name: 'Arizona',
    favorite: 'DEM',
    price: 54,
    volume: '$3.1M',
    openInterest: 42000,
  },
  AR: {
    productConid: 10004,
    stateCode: 'AR',
    name: 'Arkansas',
    favorite: 'GOP',
    price: 95,
    volume: '$200K',
    openInterest: 2100,
  },
  CA: {
    productConid: 10005,
    stateCode: 'CA',
    name: 'California',
    favorite: 'DEM',
    price: 88,
    volume: '$5.4M',
    openInterest: 68000,
  },
  CO: {
    productConid: 10006,
    stateCode: 'CO',
    name: 'Colorado',
    favorite: 'DEM',
    price: 72,
    volume: '$1.1M',
    openInterest: 15600,
  },
  CT: {
    productConid: 10007,
    stateCode: 'CT',
    name: 'Connecticut',
    favorite: 'DEM',
    price: 81,
    volume: '$340K',
    openInterest: 4800,
  },
  DC: {
    productConid: 10008,
    stateCode: 'DC',
    name: 'District of Columbia',
    favorite: 'DEM',
    price: 98,
    volume: '$50K',
    openInterest: 500,
  },
  DE: {
    productConid: 10009,
    stateCode: 'DE',
    name: 'Delaware',
    favorite: 'DEM',
    price: 78,
    volume: '$120K',
    openInterest: 1500,
  },
  FL: {
    productConid: 10010,
    stateCode: 'FL',
    name: 'Florida',
    favorite: 'GOP',
    price: 82,
    volume: '$4.5M',
    openInterest: 55000,
  },
  GA: {
    productConid: 10011,
    stateCode: 'GA',
    name: 'Georgia',
    favorite: 'GOP',
    price: 64,
    volume: '$2.8M',
    openInterest: 32000,
  },
  HI: {
    productConid: 10012,
    stateCode: 'HI',
    name: 'Hawaii',
    favorite: 'DEM',
    price: 94,
    volume: '$90K',
    openInterest: 800,
  },
  ID: {
    productConid: 10013,
    stateCode: 'ID',
    name: 'Idaho',
    favorite: 'GOP',
    price: 96,
    volume: '$110K',
    openInterest: 1200,
  },
  IL: {
    productConid: 10014,
    stateCode: 'IL',
    name: 'Illinois',
    favorite: 'DEM',
    price: 76,
    volume: '$1.5M',
    openInterest: 18900,
  },
  IN: {
    productConid: 10015,
    stateCode: 'IN',
    name: 'Indiana',
    favorite: 'GOP',
    price: 84,
    volume: '$890K',
    openInterest: 9400,
  },
  IA: {
    productConid: 10016,
    stateCode: 'IA',
    name: 'Iowa',
    favorite: 'GOP',
    price: 74,
    volume: '$670K',
    openInterest: 7200,
  },
  KS: {
    productConid: 10017,
    stateCode: 'KS',
    name: 'Kansas',
    favorite: 'GOP',
    price: 62,
    volume: '$550K',
    openInterest: 6100,
  },
  KY: {
    productConid: 10018,
    stateCode: 'KY',
    name: 'Kentucky',
    favorite: 'DEM',
    price: 58,
    volume: '$1.2M',
    openInterest: 14500,
  },
  LA: {
    productConid: 10019,
    stateCode: 'LA',
    name: 'Louisiana',
    favorite: 'GOP',
    price: 88,
    volume: '$430K',
    openInterest: 4900,
  },
  ME: {
    productConid: 10020,
    stateCode: 'ME',
    name: 'Maine',
    favorite: 'DEM',
    price: 62,
    volume: '$310K',
    openInterest: 3800,
  },
  MD: {
    productConid: 10021,
    stateCode: 'MD',
    name: 'Maryland',
    favorite: 'DEM',
    price: 85,
    volume: '$900K',
    openInterest: 11200,
  },
  MA: {
    productConid: 10022,
    stateCode: 'MA',
    name: 'Massachusetts',
    favorite: 'DEM',
    price: 91,
    volume: '$760K',
    openInterest: 8400,
  },
  MI: {
    productConid: 10023,
    stateCode: 'MI',
    name: 'Michigan',
    favorite: 'DEM',
    price: 56,
    volume: '$4.2M',
    openInterest: 48000,
  },
  MN: {
    productConid: 10024,
    stateCode: 'MN',
    name: 'Minnesota',
    favorite: 'DEM',
    price: 64,
    volume: '$1.8M',
    openInterest: 21000,
  },
  MS: {
    productConid: 10025,
    stateCode: 'MS',
    name: 'Mississippi',
    favorite: 'GOP',
    price: 82,
    volume: '$240K',
    openInterest: 3100,
  },
  MO: {
    productConid: 10026,
    stateCode: 'MO',
    name: 'Missouri',
    favorite: 'GOP',
    price: 81,
    volume: '$650K',
    openInterest: 7800,
  },
  MT: {
    productConid: 10027,
    stateCode: 'MT',
    name: 'Montana',
    favorite: 'GOP',
    price: 78,
    volume: '$420K',
    openInterest: 5400,
  },
  NE: {
    productConid: 10028,
    stateCode: 'NE',
    name: 'Nebraska',
    favorite: 'GOP',
    price: 86,
    volume: '$180K',
    openInterest: 2400,
  },
  NV: {
    productConid: 10029,
    stateCode: 'NV',
    name: 'Nevada',
    favorite: 'GOP',
    price: 52,
    volume: '$2.9M',
    openInterest: 34000,
  },
  NH: {
    productConid: 10030,
    stateCode: 'NH',
    name: 'New Hampshire',
    favorite: 'DEM',
    price: 53,
    volume: '$1.1M',
    openInterest: 12800,
  },
  NJ: {
    productConid: 10031,
    stateCode: 'NJ',
    name: 'New Jersey',
    favorite: 'DEM',
    price: 68,
    volume: '$2.4M',
    openInterest: 28000,
  },
  NM: {
    productConid: 10032,
    stateCode: 'NM',
    name: 'New Mexico',
    favorite: 'DEM',
    price: 64,
    volume: '$540K',
    openInterest: 6200,
  },
  NY: {
    productConid: 10033,
    stateCode: 'NY',
    name: 'New York',
    favorite: 'DEM',
    price: 72,
    volume: '$3.8M',
    openInterest: 42000,
  },
  NC: {
    productConid: 10034,
    stateCode: 'NC',
    name: 'North Carolina',
    favorite: 'DEM',
    price: 61,
    volume: '$2.1M',
    openInterest: 26000,
  },
  ND: {
    productConid: 10035,
    stateCode: 'ND',
    name: 'North Dakota',
    favorite: 'GOP',
    price: 94,
    volume: '$100K',
    openInterest: 1100,
  },
  OH: {
    productConid: 10036,
    stateCode: 'OH',
    name: 'Ohio',
    favorite: 'GOP',
    price: 78,
    volume: '$1.9M',
    openInterest: 22000,
  },
  OK: {
    productConid: 10037,
    stateCode: 'OK',
    name: 'Oklahoma',
    favorite: 'GOP',
    price: 91,
    volume: '$320K',
    openInterest: 4100,
  },
  OR: {
    productConid: 10038,
    stateCode: 'OR',
    name: 'Oregon',
    favorite: 'DEM',
    price: 74,
    volume: '$670K',
    openInterest: 8200,
  },
  PA: {
    productConid: 12345,
    stateCode: 'PA',
    name: 'Pennsylvania',
    favorite: 'DEM',
    price: 64,
    volume: '$5.1M',
    openInterest: 62000,
  },
  RI: {
    productConid: 10040,
    stateCode: 'RI',
    name: 'Rhode Island',
    favorite: 'DEM',
    price: 84,
    volume: '$140K',
    openInterest: 1800,
  },
  SC: {
    productConid: 10041,
    stateCode: 'SC',
    name: 'South Carolina',
    favorite: 'GOP',
    price: 86,
    volume: '$450K',
    openInterest: 5800,
  },
  SD: {
    productConid: 10042,
    stateCode: 'SD',
    name: 'South Dakota',
    favorite: 'GOP',
    price: 92,
    volume: '$110K',
    openInterest: 1300,
  },
  TN: {
    productConid: 10043,
    stateCode: 'TN',
    name: 'Tennessee',
    favorite: 'GOP',
    price: 89,
    volume: '$280K',
    openInterest: 3600,
  },
  TX: {
    productConid: 10044,
    stateCode: 'TX',
    name: 'Texas',
    favorite: 'GOP',
    price: 78,
    volume: '$6.2M',
    openInterest: 74000,
  },
  UT: {
    productConid: 10045,
    stateCode: 'UT',
    name: 'Utah',
    favorite: 'GOP',
    price: 88,
    volume: '$190K',
    openInterest: 2100,
  },
  VT: {
    productConid: 10046,
    stateCode: 'VT',
    name: 'Vermont',
    favorite: 'GOP',
    price: 72,
    volume: '$230K',
    openInterest: 2800,
  },
  VA: {
    productConid: 10047,
    stateCode: 'VA',
    name: 'Virginia',
    favorite: 'GOP',
    price: 56,
    volume: '$3.5M',
    openInterest: 38000,
  },
  WA: {
    productConid: 10048,
    stateCode: 'WA',
    name: 'Washington',
    favorite: 'DEM',
    price: 76,
    volume: '$1.2M',
    openInterest: 15400,
  },
  WV: {
    productConid: 10049,
    stateCode: 'WV',
    name: 'West Virginia',
    favorite: 'GOP',
    price: 94,
    volume: '$210K',
    openInterest: 2400,
  },
  WI: {
    productConid: 10050,
    stateCode: 'WI',
    name: 'Wisconsin',
    favorite: 'DEM',
    price: 51,
    volume: '$4.8M',
    openInterest: 58000,
  },
  WY: {
    productConid: 10051,
    stateCode: 'WY',
    name: 'Wyoming',
    favorite: 'GOP',
    price: 96,
    volume: '$80K',
    openInterest: 900,
  },
};

/**
 * House seat counts per state (for generating mock House data)
 */
const HOUSE_SEAT_COUNTS: Partial<Record<USStateCode, number>> = {
  AL: 7,
  AK: 1,
  AZ: 9,
  AR: 4,
  CA: 52,
  CO: 8,
  CT: 5,
  DE: 1,
  FL: 28,
  GA: 14,
  HI: 2,
  ID: 2,
  IL: 17,
  IN: 9,
  IA: 4,
  KS: 4,
  KY: 6,
  LA: 6,
  ME: 2,
  MD: 8,
  MA: 9,
  MI: 13,
  MN: 8,
  MS: 4,
  MO: 8,
  MT: 2,
  NE: 3,
  NV: 4,
  NH: 2,
  NJ: 12,
  NM: 3,
  NY: 26,
  NC: 14,
  ND: 1,
  OH: 15,
  OK: 5,
  OR: 6,
  PA: 17,
  RI: 2,
  SC: 7,
  SD: 1,
  TN: 9,
  TX: 38,
  UT: 4,
  VT: 1,
  VA: 11,
  WA: 10,
  WV: 3,
  WI: 8,
  WY: 1,
};

/**
 * Generate House district contracts for a state
 */
function generateHouseContracts(stateCode: USStateCode): ElectionContract[] {
  const gov = GOVERNOR_CONTRACT_DATA[stateCode];
  const count = HOUSE_SEAT_COUNTS[stateCode] || 1;

  return Array.from({ length: count }, (_, i) => ({
    productConid: 20000 + (gov.productConid - 10000) * 100 + i, // Generate unique productConid for each House district
    stateCode,
    name: gov.name,
    district: `District ${i + 1}`,
    favorite: (Math.random() > 0.5 ? 'GOP' : 'DEM') as PartyCode,
    price: Math.round(Math.min(99, Math.max(1, 50 + (Math.random() * 40 - 20)))),
    volume: `$${(Math.random() * 500).toFixed(1)}K`,
    openInterest: Math.floor(Math.random() * 5000),
  }));
}

/**
 * House race contract data by state
 */
export const HOUSE_CONTRACT_DATA: Record<USStateCode, ElectionContract[]> = Object.keys(GOVERNOR_CONTRACT_DATA).reduce(
  (acc, key) => {
    const stateCode = key as USStateCode;
    acc[stateCode] = generateHouseContracts(stateCode);
    return acc;
  },
  {} as Record<USStateCode, ElectionContract[]>,
);

/**
 * States without Senate races in 2026
 */
const NO_SENATE_STATES: USStateCode[] = ['AZ', 'CA', 'CT', 'HI', 'IN', 'MD', 'NV', 'NY', 'ND', 'PA', 'UT', 'WI'];

/**
 * Senate race contract data
 * Only includes states with Senate races in 2026
 */
export const SENATE_CONTRACT_DATA: Partial<Record<USStateCode, ElectionContract>> = Object.keys(
  GOVERNOR_CONTRACT_DATA,
).reduce(
  (acc, key) => {
    const stateCode = key as USStateCode;
    if (NO_SENATE_STATES.includes(stateCode)) return acc;

    const gov = GOVERNOR_CONTRACT_DATA[stateCode];
    acc[stateCode] = {
      ...gov,
      productConid: 30000 + (gov.productConid - 10000), // Generate unique productConid for Senate (30000 range)
      price: Math.round(Math.min(99, Math.max(1, gov.price + (Math.random() * 14 - 7)))),
    };
    return acc;
  },
  {} as Partial<Record<USStateCode, ElectionContract>>,
);

/**
 * Get all House contracts as a flat array
 */
export function getAllHouseContracts(): ElectionContract[] {
  return Object.values(HOUSE_CONTRACT_DATA).flat();
}

/**
 * Get all Senate contracts as an array
 */
export function getAllSenateContracts(): ElectionContract[] {
  return Object.values(SENATE_CONTRACT_DATA).filter((c): c is ElectionContract => c !== undefined);
}

/**
 * Summary statistics
 */
export function getElectionStats(contracts: ElectionContract[]) {
  return {
    total: contracts.length,
    gopLeading: contracts.filter((c) => c.favorite === 'GOP').length,
    demLeading: contracts.filter((c) => c.favorite === 'DEM').length,
    tossups: contracts.filter((c) => c.price >= 45 && c.price <= 55).length,
    totalVolume: contracts.reduce((sum, c) => {
      const match = c.volume.match(/\$?([\d.]+)([KMB])?/);
      if (!match) return sum;
      const [, num, suffix] = match;
      const multiplier = suffix === 'M' ? 1_000_000 : suffix === 'B' ? 1_000_000_000 : 1_000;
      return sum + parseFloat(num) * multiplier;
    }, 0),
    totalOpenInterest: contracts.reduce((sum, c) => sum + c.openInterest, 0),
  };
}
